export class LoginCustom {
  public static handleSignInFormSubmit () {
    $('#m_login_signin_submit').click(function (e) {
      const form = $(this).closest('form')
      form.validate({
        rules: {
          email: {
            required: true,
            email: true
          },
          password: {
            required: true
          }
        }
      })
      if (!form.valid()) {
        e.preventDefault()
        return
      }
    })
  }

  public static displaySignUpForm () {
    const login = $('#m_login')
    login.removeClass('m-login--forget-password')
    login.removeClass('m-login--signin')

    login.addClass('m-login--signup');
    (login.find('.m-login__signup') as any).animateClass('flipInX animated')
  }

  public static displaySignInForm () {
    const login = $('#m_login')
    login.removeClass('m-login--forget-password')
    login.removeClass('m-login--signup')
    try {
      $('form')
        .data('validator')
        .resetForm()
    } catch (e) {}

    login.addClass('m-login--signin');
    (login.find('.m-login__signin') as any).animateClass('flipInX animated')
  }

  public static displayForgetPasswordForm () {
    const login = $('#m_login')
    login.removeClass('m-login--signin')
    login.removeClass('m-login--signup')

    login.addClass('m-login--forget-password');
    (login.find('.m-login__forget-password') as any).animateClass(
      'flipInX animated'
    )
  }

  public static handleFormSwitch () {
    $('#m_login_forget_password').click(function (e) {
      e.preventDefault()
      LoginCustom.displayForgetPasswordForm()
    })

    $('#m_login_forget_password_cancel').click(function (e) {
      e.preventDefault()
      LoginCustom.displaySignInForm()
    })

    $('#m_login_signup').click(function (e) {
      e.preventDefault()
      LoginCustom.displaySignUpForm()
    })

    $('#m_login_signup_cancel').click(function (e) {
      e.preventDefault()
      LoginCustom.displaySignInForm()
    })
  }

  public static handleSignUpFormSubmit () {
    $('#m_login_signup_submit').click(function (e) {
      const btn = $(this)
      const form = $(this).closest('form')
      form.validate({
        rules: {
          fullname: {
            required: true
          },
          email: {
            required: true
          },
          password: {
            required: true
          },
          rpassword: {
            required: true
          },
          agree: {
            required: true
          }
        }
      })
      if (!form.valid()) {
        e.preventDefault()
        return
      }
    })
  }

  public static handleForgetPasswordFormSubmit () {
    $('#m_login_forget_password_submit').click(function (e) {
      const btn = $(this)
      const form = $(this).closest('form')
      form.validate({
        rules: {
          email: {
            required: true,
            email: true
          }
        }
      })
      if (!form.valid()) {
        e.preventDefault()
        return
      }
    })
  }

  public static init () {
    LoginCustom.handleFormSwitch()
    LoginCustom.handleSignInFormSubmit()
    LoginCustom.handleSignUpFormSubmit()
    LoginCustom.handleForgetPasswordFormSubmit()
  }
}
